import { z } from "zod";

import { DbEnum } from "../../generated/prisma-enums";

/**
 * The deployment slot as it appears IN A LOG RECORD, which is lower-case.
 *
 * 🔴 DELIBERATELY NOT `VibeDeploymentColorSchema`. That one is the DATABASE
 * enum and spells its values `BLUE` / `GREEN`; `vibeAppTelemetryEnv` writes
 * `identity.color.toLowerCase()` into the OTel resource attribute, so the value
 * Loki holds is `blue` / `green`. Matching a log record against the database
 * spelling returns nothing, and returns it silently — the single most likely way
 * for this filter to look implemented and do nothing.
 *
 * The `satisfies` below is what stops the two drifting: every value here must be
 * the lower-case form of a real `VibeDeploymentColor`, so renaming the database
 * enum fails this file at compile time rather than at query time.
 */
type LowercaseDeploymentColor = Lowercase<(typeof DbEnum.VIBE_DEPLOYMENT_COLOR_VALUES)[number]>;

export const VIBE_LOG_COLOR_VALUES = [
  "blue",
  "green"
] as const satisfies readonly LowercaseDeploymentColor[];

export const VibeLogColorSchema = z.enum(VIBE_LOG_COLOR_VALUES);
export type VibeLogColor = z.infer<typeof VibeLogColorSchema>;
